// eslint-disable-next-line import/prefer-default-export
import http from '../../libs/axios'

export const hirePurchase = {
  namespaced: true,
  state: {
    items: [],
    cashSales: [],
    purchasers: [],
    contracts: [],
    occupations: [],
    contractPayments: [],
    totalContracts: 1,
    totalCashSales: 1,
    totalPayments: 1,
    filter: {
      start: null,
      end: null,
      specificDay: false,
    },
    paymentFilter: {
      start: null,
      end: null,
      specificDay: false,
    },
    dashboardStats: {
      items: null,
      purchase: null,
      sales: null,
    },
  },
  actions: {
    loadItems({ commit }) {
      http.get('hire-purchase/items')
        .then(res => {
          commit('setItems', res.data)
        })
    },
  },
  mutations: {
    setDashboardData(state, data) {
      state.dashboardStats = data
    },
    setCashSaleFilter(state, filter) {
      state.filter = filter
    },
    setPaymentFilter(state, filter) {
      state.paymentFilter = filter
    },
    setCashSales(state, data) {
      state.cashSales = data.data
      state.totalCashSales = data.total
    },
    addCashSale: (state, cashSale) => {
      state.cashSales = [cashSale, ...state.cashSales]
    },
    updateCashSale: (state, cashSale) => {
      state.cashSales = state.cashSales.map(datum => {
        if (datum.id === cashSale.id) {
          return cashSale
        }
        return datum
      })
    },
    removeCashSale: (state, id) => {
      state.cashSales = state.cashSales.filter(datum => +datum.id !== +id)
    },
    setPurchasers(state, data) {
      state.purchasers = data.purchasers
    },
    addPurchaser: (state, purchaser) => {
      state.purchasers = [...state.purchasers, purchaser]
    },
    updatePurchaser: (state, purchaser) => {
      state.purchasers = state.purchasers.map(datum => {
        if (datum.id === purchaser.id) {
          return purchaser
        }
        return datum
      })
    },
    removePurchaser: (state, id) => {
      state.purchasers = state.purchasers.filter(datum => +datum.id !== +id)
    },
    setContracts(state, data) {
      state.contracts = data.data
      state.totalContracts = data.total
    },
    addContract: (state, contract) => {
      state.contracts = [contract, ...state.contracts]
    },
    updateContract: (state, contract) => {
      state.contracts = state.contracts.map(datum => {
        if (datum.id === contract.id) {
          const d = { ...datum, ...contract }
          return d
        }
        return datum
      })
    },
    removeContract: (state, id) => {
      state.contracts = state.contracts.filter(datum => +datum.id !== +id)
    },
    setContractPayments(state, data) {
      state.contractPayments = data.data
      state.totalPayments = data.total
    },
    addContractPayments: (state, contractPayments) => {
      state.contractPayments = [...contractPayments, ...state.contractPayments]
    },
    addContractPayment: (state, contractPayment) => {
      state.contractPayments = [contractPayment, ...state.contractPayments]
    },
    reverseContractPayment: (state, transaction) => {
      // make this more consistent with transactions and loan payments {data:[],total:0} and not separated like now
      state.contractPayments = state.contractPayments.map(pay => {
        if (pay.id === transaction) {
          return { ...pay, reversed: true }
        }
        return pay
      })
    },

    updateContractPayment: (state, contractPayment) => {
      state.contractPayments = state.contractPayments.map(datum => {
        if (datum.id === contractPayment.id) {
          return contractPayment
        }
        return datum
      })
    },
    removeContractPayment: (state, id) => {
      state.contractPayments = state.contractPayments.filter(datum => +datum.id !== +id)
    },
    setItems(state, data) {
      state.items = data
    },
    addItem: (state, item) => {
      state.items = [item, ...state.items]
    },
    updateItem: (state, item) => {
      state.items = state.items.map(datum => {
        if (datum.id === item.id) {
          return item
        }
        return datum
      })
    },
    removeItem: (state, id) => {
      state.items = state.items.filter(datum => +datum.id !== +id)
    },
  },
  getters: {
    purchasers(state) {
      return state.purchasers.map(u => ({ ...u, full_name: `${u.first_name} ${u.last_name}` }))
    },
    cashSales(state) {
      return state.cashSales.map(c => ({ ...c, name: `${c.customer}-${c.reference}(${(c.amount_billed).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})` }))
    },
    contracts(state) {
      return state.contracts.map(c => ({ ...c, name: `${c.customer}-${c.reference}(${(c.amount_billed - c.total_paid).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})` }))
    },
    payments(state) {
      return state.contractPayments
    },
    paymentFilter(state) {
      return state.paymentFilter
    },
    totalPayments(state) {
      return state.totalPayments
    },
    items(state) {
      return state.items
    },
    occupations(state) {
      return state.occupations
    },
    totalContracts(state) {
      return state.totalContracts
    },
    totalCashSales(state) {
      return state.totalCashSales
    },
    cashSaleFilter(state) {
      return state.filter
    },
    dashboardStats(state) {
      return state.dashboardStats
    },
  },
}
